/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminLandmarkDto, AdminLandmarkImageDto, AdminLandmarkRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminLandmarkService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name GetLandmark
   * @summary Get Landmark by ID
   * @request GET:/v1/admin/landmarks/{landmarkId}
   * @secure
   */
  getLandmark = (landmarkId: number, params: RequestParams = {}) =>
    this.http.request<AdminLandmarkDto, any>({
      path: `/v1/admin/landmarks/${landmarkId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name UpdateLandmark
   * @summary Update a Landmark
   * @request PUT:/v1/admin/landmarks/{landmarkId}
   * @secure
   */
  updateLandmark = (
    landmarkId: number,
    data: AdminLandmarkRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminLandmarkDto, any>({
      path: `/v1/admin/landmarks/${landmarkId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name DeleteLandmark
   * @summary Delete a Landmark
   * @request DELETE:/v1/admin/landmarks/{landmarkId}
   * @secure
   */
  deleteLandmark = (landmarkId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/landmarks/${landmarkId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name GetLandmarks
   * @summary Get Landmarks
   * @request GET:/v1/admin/landmarks
   * @secure
   */
  getLandmarks = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminLandmarkDto[], any>({
      path: `/v1/admin/landmarks`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name CreateLandmark
   * @summary Create a Landmark
   * @request POST:/v1/admin/landmarks
   * @secure
   */
  createLandmark = (data: AdminLandmarkRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminLandmarkDto, any>({
      path: `/v1/admin/landmarks`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name GetLandmarkImages
   * @summary Get Images for a Landmark
   * @request GET:/v1/admin/landmarks/{landmarkId}/images
   * @secure
   */
  getLandmarkImages = (
    landmarkId: number,
    query?: {
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["seq,ASC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminLandmarkImageDto[], any>({
      path: `/v1/admin/landmarks/${landmarkId}/images`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name CreateLandmarkImage
   * @summary Create a Image
   * @request POST:/v1/admin/landmarks/{landmarkId}/images
   * @secure
   */
  createLandmarkImage = (
    landmarkId: number,
    query: {
      /** @format int32 */
      seq: number;
    },
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminLandmarkImageDto, any>({
      path: `/v1/admin/landmarks/${landmarkId}/images`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminLandmarkService
   * @name DeleteLandmarkImage
   * @summary Delete a Landmark Image
   * @request DELETE:/v1/admin/landmarks/{landmarkId}/images/{landmarkImageId}
   * @secure
   */
  deleteLandmarkImage = (landmarkId: number, landmarkImageId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/landmarks/${landmarkId}/images/${landmarkImageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
